const BASE_URL = 'https://us-central1-fundacja-miec-pasje.cloudfunctions.net/'
// const BASE_URL = 'http://localhost:5001/fundacja-miec-pasje/us-central1/'

export const SEND_EMAIL_URL = BASE_URL + 'sendMail'
